import Vue from 'vue';
import Vuex from 'vuex';
import {db, moment} from '../main'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    userDetails: {},
    users: [],
    events: [],
    projects: [],
    roles: [],
    currentlySelectedUser: null,
    currentlySelectedYear: null,
    currentlySelectedMonth: null,
    currentlySelectedViewMode: 'list',

    filterSelectedUser: null,
    filterSelectedYear: null,
    filterSelectedMonth: null,
    filterSelectedMunicipality: '',
    filterSelectedProjects: [],
  },
  mutations: {

    RETRIEVE_USER_DETAILS(state, payload) {
      console.log("RETRIEVE_USER_DETAILS payload", payload);
      Vue.set(state, 'userDetails', payload);
    },

    RETRIEVE_USERS(state, payload) {
      console.log("RETRIEVE_USERS payload", payload);
      Vue.set(state, 'users', payload);
    },

    RETRIEVE_EVENTS(state, payload) {
      console.log("RETRIEVE_EVENTS payload", payload);
      Vue.set(state, 'events', payload);
    },

    RETRIEVE_PROJECTS(state, payload) {
      console.log("RETRIEVE_PROJECTS payload", payload);
      Vue.set(state, 'projects', payload);
    },

    RETRIEVE_ROLES(state, payload) {
      console.log("RETRIEVE_ROLES payload", payload);
      Vue.set(state, 'roles', payload);
    },

    SET_CURRENTLY_SELECTED_USER(state, payload) {
      console.log("SET_CURRENTLY_SELECTED_USER payload", payload);
      Vue.set(state, 'currentlySelectedUser', payload);
    },

    SET_CURRENTLY_SELECTED_YEAR(state, payload) {
      console.log("SET_CURRENTLY_SELECTED_YEAR payload", payload);
      Vue.set(state, 'currentlySelectedYear', payload);
    },

    SET_CURRENTLY_SELECTED_MONTH(state, payload) {
      console.log("SET_CURRENTLY_SELECTED_MONTH payload", payload);
      Vue.set(state, 'currentlySelectedMonth', payload.toString());
    },

    SET_CURRENTLY_SELECTED_VIEW_MODE(state, payload) {
      console.log("SET_CURRENTLY_SELECTED_VIEW_MODE payload", payload);
      Vue.set(state, 'currentlySelectedViewMode', payload);
    },

    SET_FILTER_SELECTED_USER(state, payload) {
      console.log("SET_FILTER_SELECTED_USER payload", payload);
      Vue.set(state, 'filterSelectedUser', payload);
    },

    SET_FILTER_SELECTED_YEAR(state, payload) {
      console.log("SET_FILTER_SELECTED_YEAR payload", payload);
      Vue.set(state, 'filterSelectedYear', payload);
    },

    SET_FILTER_SELECTED_MONTH(state, payload) {
      console.log("SET_FILTER_SELECTED_MONTH payload", payload);
      Vue.set(state, 'filterSelectedMonth', payload);
    },

    SET_FILTER_SELECTED_MUNICIPALITY(state, payload) {
      console.log("SET_FILTER_SELECTED_MUNICIPALITY payload", payload);
      Vue.set(state, 'filterSelectedMunicipality', payload);
    },

    SET_FILTER_SELECTED_PROJECTS(state, payload) {
      console.log("SET_FILTER_SELECTED_PROJECTS payload", payload);
      Vue.set(state, 'filterSelectedProjects', payload);
    },

    RESET_STORE(state) {
      console.log("RESET_STORE");
      Vue.set(state, "userDetails", {} );
      Vue.set(state, "users", {} );
      Vue.set(state, "events", {} );
      Vue.set(state, "projects", {} );
      Vue.set(state, "roles", {} );
    }

  },
  actions: {
    retrieveUserDetails(context) {
      let userData = sessionStorage.getItem("DP_user") ? JSON.parse(sessionStorage.getItem("DP_user")) : {};
      context.commit("RETRIEVE_USER_DETAILS", userData);
    },

    async retrieveUsers(context, forceUpdate) {
      const _this = this

      // retrieve data only once or if update is forced
      if (_this.state.users.length && !forceUpdate) {
        console.log("Users data already in store!");
        return;
      }

      await db.collection('users')
        .get()
        .then(querySnapshot => {
          let users = querySnapshot.docs.map(doc => doc.data())
          context.commit("RETRIEVE_USERS", users);
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error retrieving users: ', error)
        })
    },

    async retrieveEvents(context, forceUpdate) {
      const _this = this

      // retrieve data only once or if update is forced
      if (_this.state.events.length > 0 && !forceUpdate) {
        console.log("Events data already in store!");
        return;
      }

      await db.collection('events')
        .get()
        .then(querySnapshot => {
          let events = querySnapshot.docs.map(doc => doc.data());
          events = _.sortBy(events, ['date']);
          context.commit("RETRIEVE_EVENTS", events);
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error retrieving events: ', error)
        })
    },

    async retrieveProjects(context, forceUpdate) {
      const _this = this

      // retrieve data only once or if update is forced
      if (_this.state.projects.length > 0 && !forceUpdate) {
        console.log("Projects data already in store!");
        return;
      }

      await db.collection('projects')
        .get()
        .then(querySnapshot => {
          let projects = querySnapshot.docs.map(doc => doc.data())
          context.commit("RETRIEVE_PROJECTS", projects);
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error retrieving projects: ', error)
        })
    },

    async retrieveRoles(context, forceUpdate) {
      const _this = this

      // retrieve data only once or if update is forced
      if (_this.state.roles.length > 0 && !forceUpdate) {
        console.log("Roles data already in store!");
        return;
      }

      await db.collection('roles')
        .get()
        .then(querySnapshot => {
          let projects = querySnapshot.docs.map(doc => doc.data())
          context.commit("RETRIEVE_ROLES", projects);
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error retrieving roles: ', error)
        })
    },

    setCurrentlySelectedUser(context, data) {
      context.commit("SET_CURRENTLY_SELECTED_USER", data);
    },

    setCurrentlySelectedYear(context, data) {
      context.commit("SET_CURRENTLY_SELECTED_YEAR", data);
    },

    setCurrentlySelectedMonth(context, data) {
      context.commit("SET_CURRENTLY_SELECTED_MONTH", data);
    },

    setCurrentlySelectedViewMode(context, data) {
      context.commit("SET_CURRENTLY_SELECTED_VIEW_MODE", data);
    },


    setFilterSelectedUser(context, data) {
      context.commit("SET_FILTER_SELECTED_USER", data);
    },

    setFilterSelectedYear(context, data) {
      context.commit("SET_FILTER_SELECTED_YEAR", data);
    },

    setFilterSelectedMonth(context, data) {
      context.commit("SET_FILTER_SELECTED_MONTH", data);
    },

    setFilterSelectedMunicipality(context, data) {
      context.commit("SET_FILTER_SELECTED_MUNICIPALITY", data);
    },

    setFilterSelectedProjects(context, data) {
      context.commit("SET_FILTER_SELECTED_PROJECTS", data);
    },


    resetStore(context){
      context.commit("RESET_STORE");
    },

  },
  getters: {
    getUserDetails: state => state.userDetails,
    getUsers: state => state.users,
    getEvents: state => state.events,
    getProjects: state => state.projects,
    getRoles: state => state.roles,
    getCurrentlySelectedUser: state => state.currentlySelectedUser ? state.currentlySelectedUser : JSON.parse(sessionStorage.getItem('DP_user')).id,
    getCurrentlySelectedYear: state => state.currentlySelectedYear ? state.currentlySelectedYear : parseInt(moment().year()),
    getCurrentlySelectedMonth: state => state.currentlySelectedMonth ? state.currentlySelectedMonth : parseInt(moment().month()),
    getCurrentlySelectedViewMode: state => state.currentlySelectedViewMode,

    getFilterSelectedUser: state => state.filterSelectedUser ? state.filterSelectedUser : null,
    getFilterSelectedYear: state => state.filterSelectedYear ? state.filterSelectedYear : parseInt(moment().year()),
    getFilterSelectedMonth: state => state.filterSelectedMonth ? state.filterSelectedMonth : parseInt(moment().month()),
    getFilterSelectedMunicipality: state => state.filterSelectedMunicipality,
    getFilterSelectedProjects: state => state.filterSelectedProjects,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js